import React from "react";
// import ReactDOM from "react-dom";
import "antd/dist/antd.css";
// import "./index.css";
import { List } from "antd";
// import { QualificationsCard } from "../Cards/QualificationsCard";
// import { ProjectCard } from "./../Cards/ProjectCard";
import { Heading } from "../CategoryHeading/Heading";
import styles from "./Experiences.module.css";
import { ExperiencesCard } from "../Cards/ExperiencesCard";

const data = [
  {
    logo: "/Images/comtron.png",
    title: "Software Developer",
    organization: "Comtronus LLP",
    duration: "September 2021 - Present | Vizag",
    navigate_to: "www.comtronusa.com/",
  },
  {
    logo: "/Images/communiti.svg",
    title: "Blockchain Developer",
    organization: "Communiti.dev",
    duration: "January 2022 - Present | Remote",
    navigate_to: "www.communiti.dev/",
  },
  {
    logo: "/Images/masai.svg",
    title: "Full Stack Engineer Fellow",
    organization: "Masai School",
    duration: "January 2021 - August 2021 | Remote",
    navigate_to: "www.masaischool.com/",
  },
];

export const Experiences = () => {
  return (
    <div className={styles.cards_container}>
      <Heading title="𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞𝐬" />
      <List
        style={{ marginTop: "2%", gap: "20%" }}
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 3,
          lg: 3,
          xl: 3,
          xxl: 3,
        }}
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <ExperiencesCard item={item}>Card content</ExperiencesCard>
          </List.Item>
        )}
      />
    </div>
  );
};
